import { useState } from 'react';

const useForm = (initialValues) => {
  const [values, setValue] = useState(initialValues);

  const setValues = (key, value) => {
    setValue({
      ...values,
      [key]: value,
    });
  };

  const handleChange = (e) => {
    setValues(e.target.getAttribute('name'), e.target.value);
  };

  const handleChangeObject = (e, object) => {
    const data = e.target.getAttribute('name').split('.');
    object = { ...object, [data[1]]: e.target.value };
    setValues(data[0], object);
  };

  const handleChangeDate = (dateMoment, fieldDate) => {
    if (typeof dateMoment === 'object') {
      const currentDate = dateMoment.format('DD/MM/YYYY');
      setValues(fieldDate, currentDate);
    }
  };

  const handleChangeCheckbox = (e) => {
    const { checked } = e.target;
    setValues(e.target.getAttribute('name'), checked);
  };

  const handleChangeCustom = (field, value) => {
    setValues(field, value);
  };

  const handleChangeTwoValues = (key1, value1, key2, value2) => {
    setValue({
      ...values,
      [key1]: value1,
      [key2]: value2,
    });
  };

  const handleChangeTreeValues = (key1, value1, key2, value2, key3, value3) => {
    setValue({
      ...values,
      [key1]: value1,
      [key2]: value2,
      [key3]: value3,
    });
  };

  const handleChangeFourValues = (
    key1,
    value1,
    key2,
    value2,
    key3,
    value3,
    key4,
    value4
  ) => {
    setValue({
      ...values,
      [key1]: value1,
      [key2]: value2,
      [key3]: value3,
      [key4]: value4,
    });
  };

  const clearForm = () => setValue(initialValues);

  return {
    values,
    handleChange,
    clearForm,
    setValue,
    handleChangeDate,
    handleChangeCheckbox,
    handleChangeCustom,
    handleChangeTwoValues,
    handleChangeTreeValues,
    handleChangeFourValues,
    handleChangeObject,
  };
};

export default useForm;
